import { render, staticRenderFns } from "./AccountsSettings.vue?vue&type=template&id=64d3b311&scoped=true"
import script from "./AccountsSettings.vue?vue&type=script&lang=js"
export * from "./AccountsSettings.vue?vue&type=script&lang=js"
import style0 from "./AccountsSettings.vue?vue&type=style&index=0&id=64d3b311&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d3b311",
  null
  
)

export default component.exports